export const staff = [
  {
    table: "table1",
    imgUrl: "assets/tables/table-1.jpeg",
    sizeY: "3",
    sizeX: "3",
  },
  {
    table: "table2",
    imgUrl: "assets/tables/table-2.jpeg",
    sizeY: "3",
    sizeX: "5",
  },
  {
    table: "horizontal",
    imgUrl: "assets/tables/horizontal.png",
    sizeY: "1",
    sizeX: "4",
  },
  {
    table: "vertical",
    imgUrl: "assets/tables/vertical.png",
    sizeY: "3",
    sizeX: "1",
  },
];
